// @flow
import * as React from 'react';
import CampaignDashboardListing from 'common/modules/campaign/domain/CampaignDashboardListing';
import CampaignV2LinkedTo from 'statsradio/modules/campaigns/components/v2/CampaignV2LinkedTo';
import { StyledRow, Td, TdEmphasis } from '../CampaignDashboardTable';

export const DAYS_TILL_CAMPAIGN_STARTS_THRESHOLD = 5;
export const START_AT_EMPHASIS_ID = 'START_AT_EMPHASIS_ID';
export const START_AT_ID = 'START_AT_ID';

interface Props {
  campaign: CampaignDashboardListing;
  history: any;
  onCampaignClick: (reference: string, history: any) => void;
}

export default function LinkedCampaignsTableRow({ campaign, onCampaignClick, history }: Props) {
  let date;
  if (campaign.isStartedSince(DAYS_TILL_CAMPAIGN_STARTS_THRESHOLD)) {
    date = <TdEmphasis id={START_AT_EMPHASIS_ID}>{campaign.startAt.fromNow()}</TdEmphasis>;
  } else {
    date = <Td id={START_AT_ID}>{campaign.startAt.fromNow()}</Td>;
  }

  return (
    <StyledRow key={campaign.reference} onClick={() => onCampaignClick(campaign.reference, history)}>
      <Td>{campaign.name}</Td>
      <Td><CampaignV2LinkedTo campaign={campaign} /></Td>
      {date}
    </StyledRow>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/linkedCampaigns/LinkedCampaignsTableRow.js